import { combineReducers, configureStore } from '@reduxjs/toolkit'
import localforage from 'localforage'
import { persistReducer, persistStore } from 'redux-persist'
import {
  metaReducer,
  optionsReducer,
  reasonsReducer,
  settingsReducer,
} from './reducers'

const persistConfig = {
  key: 'root',
  storage: localforage,
  // Only persist settings — list state (options/reasons/meta) always starts fresh
  whitelist: ['settings'],
}

const rootReducer = combineReducers({
  reasons: reasonsReducer,
  options: optionsReducer,
  meta: metaReducer,
  settings: settingsReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export const persistor = persistStore(store, { manualPersist: true })

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
